import { Component, Input, OnInit, LOCALE_ID, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import OverlayScrollbars from 'overlayscrollbars';
import { PointStoreProductEditService } from 'src/app/gamification/marketplace/admin/services/point-store-product-edit.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ValidatorService } from '../../services/validator.service';
import { GridApi, GridOptions } from 'ag-grid-community';
import { AssignmentDefinition, GroupDTO } from '../cv-point-store-product-assignment-cxone/cv-point-store-product-assignment-cxone.model';
import { cloneDeep } from 'lodash';
import { PointStoreProductAssignmentService } from 'src/app/gamification/marketplace/admin/services/point-store-product-assignment.service';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-point-store-product-summary-cxone',
    templateUrl: './cv-point-store-product-summary-cxone.component.html',
    styleUrls: ['./cv-point-store-product-summary-cxone.component.scss']
})
export class CvPointStoreProductSummaryCxoneComponent implements OnInit {
    @Input() formDataBinding: FormGroup;
    @ViewChild('pointStoreProductSummaryGrid') agGrid: AgGridAngular;

    pspes: any = null;
    saleVariationFlag = false;
    initialVariationPrice: any = 0;
    assignmentsSearchPlaceholder: string;
    assignmentsLabel: string;
    noResultFound: boolean = false;
    DateFormat = "MMM d, y";

    public gridOptions: GridOptions = null;
    private selectedAssignment: AssignmentDefinition = null;
    public assignments: GroupDTO[] = [];

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        private pointStoreProductEditService: PointStoreProductEditService,
        public cvLocalizationService: CVLocalizationService,
        public validatorService: ValidatorService,
        private pointStoreProductAssignmentService: PointStoreProductAssignmentService
    ) {
        this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    }

    ngOnInit(): void {
        this.assignmentsSearchPlaceholder = this.getLocalizationText('MarketPlace_Management', 'Search', 'Search') + '...';
        this.assignmentsLabel = '0 ' + this.getLocalizationText('MarketPlace_Management', 'Groups', 'Groups').toLocaleLowerCase();
        this.loadAssignments();
        this.setupAgGrid();
    }

    public loadAssignments(): void {
        this.selectedAssignment = {
            AssignAll: false,
            Emp: [],
            Level: 0
        };
        for (const item of this.pointStoreProductAssignmentService.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp) {
            this.selectedAssignment.Emp.push(item);
            this.selectedAssignment.Level = item.GroupLevel;
        }
        this.assignments = cloneDeep(this.selectedAssignment.Emp);
    }

    public setupAgGrid(): void {
        this.gridOptions = {
            headerHeight: (this.assignments.length > 0) ? 44 : 0,
            suppressRowClickSelection: true,
            rowSelection: 'multiple',
            suppressMovableColumns: true,
            suppressContextMenu: true,
            rowClass: 'product-assignment-row',
            rowHeight: 36,
            defaultColDef: {
                flex: 1,
                sortable: true,
                resizable: false,
                suppressMenu: true,
            },
            columnDefs: [
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationText('MarketPlace_Management', 'Agent', 'Agent').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 1,
                },
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationText('MarketPlace_Management', 'Team', 'Team').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 2,
                },
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationText('MarketPlace_Management', 'Company', 'Company').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 3,
                },
                {
                    colId: "GroupID",
                    field: "Email",
                    headerName: this.getLocalizationText('MarketPlace_Management', 'Team', 'Team').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 1,
                },
            ],
            overlayNoRowsTemplate: `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                  <svg class="cxoneFavoriteState mb-2">
                                      <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                                  </svg>
                                  <p class="cxone-error-text">${this.getLocalizationText('MarketPlace_Management', "No_Group_Assigned_Yet", "No group assigned yet")}</p>
                              </div>`,
            onGridReady: (params) => {
                params.api.setGridOption('rowData', []);
                params.api.setGridOption('rowData', this.assignments);
            },
            onRowDataUpdated: (event) => {
                this.assignGridMessage();
                this.updateAssignmentsLabel(event.api);
            },
            onFilterChanged: (event) => {
                this.assignGridMessage();
                this.updateAssignmentsLabel(event.api);
            }
        };
    }

    private assignGridMessage(): void {
        if (this.assignments.length > 0 && this.agGrid?.api.getDisplayedRowCount() == 0) {
            this.noResultFound = true;
            this.updateNoRowsMessage();
        } else {
            this.updateNoAssignmentMessage();
        }
    }

    private updateNoRowsMessage(): void {
        this.gridOptions.overlayNoRowsTemplate = `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                                <svg class="cxoneFavoriteState mb-2">
                                                    <use href="../App_Themes/CXone/icons/no-results.svg#no-results"></use>
                                                </svg>
                                                <p class="cxoneEmptyText illustration-text">${this.getLocalizationText('MarketPlace_Management', 'No_Result_Found', 'No result found')}</p>
                                            </div>`;
    }

    private updateNoAssignmentMessage(): void {
        this.gridOptions.overlayNoRowsTemplate = `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                                  <svg class="cxoneFavoriteState mb-2">
                                                      <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                                                  </svg>
                                                  <p class="cxone-error-text illustration-text">${this.getLocalizationText('MarketPlace_Management', "No_Group_Assigned_Yet", "No group assigned yet")}</p>
                                              </div>`;
    }

    private updateAssignmentsLabel(api: GridApi): void {
        let assignmentLabel = "";
        let assignmentCount = api.getDisplayedRowCount();
        let singluar: boolean = assignmentCount == 1;
        switch (this.selectedAssignment.Level) {
            //agent
            case 1:
                assignmentLabel = singluar ? this.getLocalizationText('MarketPlace_Management', 'Agent', 'Agent').toLocaleLowerCase() : this.getLocalizationText('MarketPlace_Management', 'Agents', 'Agents').toLocaleLowerCase();
                break;
            //team
            case 2:
                assignmentLabel = singluar ? this.getLocalizationText('MarketPlace_Management', 'Team', 'Team').toLocaleLowerCase() : this.getLocalizationText('MarketPlace_Management', 'Teams', 'Teams').toLocaleLowerCase();
                break;
            //company
            case 3:
                assignmentLabel = singluar ? this.getLocalizationText('MarketPlace_Management', 'Company', 'Company').toLocaleLowerCase() : this.getLocalizationText('MarketPlace_Management', 'Companies', 'Companies').toLocaleLowerCase();
                break;
            default:
                assignmentLabel = this.getLocalizationText('MarketPlace_Management', 'Groups', 'Groups').toLocaleLowerCase();
        }
        if (assignmentLabel != "")
            this.assignmentsLabel = `${assignmentCount} ${assignmentLabel}`;
        else
            this.assignmentsLabel = assignmentLabel;

        if (api.getDisplayedRowCount() == 0)
            api.showNoRowsOverlay();
        else
            api.hideOverlay();
    }

    public onAssignmentsFilterChange(searchText): void {
        this.noResultFound = false;
        this.agGrid?.api.setGridOption('quickFilterText', searchText);
    }

    getProductInfo(property) {
        if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
            return "";

        switch (property) {
            case "title":
                return this.pspes.modifiedPointStoreProduct.Title;
                break;
            case "description":
                return this.pspes.modifiedPointStoreProduct.Description;
                break;
            case "category":
                return this.pspes.modifiedPointStoreProduct.Category;
                break;
            case "subCategory":
                return this.pspes.modifiedPointStoreProduct.SubCategory;
                break;
            case "price":
                return this.pspes.modifiedPointStoreProduct.Price;
                break;
            case "quantity":
                if (this.pspes.modifiedPointStoreProduct.HasProductVariations) {
                    let totalQuantity = null;
                    let UnlimitedCount = 0;
                    this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
                        if (variation.VariationQuantity != null) {
                            totalQuantity = totalQuantity != null ? totalQuantity + Number(variation.VariationQuantity.toString().replace(',', '')) : Number(variation.VariationQuantity.toString().replace(',', ''));
                        } else {
                            UnlimitedCount++;
                        }
                    });
                    if (totalQuantity == null || UnlimitedCount === this.pspes.modifiedPointStoreProduct.VariationsData.length)
                        return this.getLocalizationText('MarketPlace_Management', 'Unlimited', 'Unlimited');
                    else if (UnlimitedCount > 0)
                        return "-";
                    else
                        return totalQuantity;
                } else {
                    if (this.pspes.modifiedPointStoreProduct.Quantity == null || this.pspes.modifiedPointStoreProduct.Quantity.length <= 0)
                        return this.getLocalizationText('MarketPlace_Management', 'Unlimited', 'Unlimited');
                    else return this.pspes.modifiedPointStoreProduct.Quantity;
                }
                break;
            case "productStart":
                return formatDate(this.pspes.modifiedPointStoreProduct.ProductStart, this.DateFormat, this.locale);
                break;
            case "productEnd":
                if (this.pspes.modifiedPointStoreProduct.ProductEnd == null || this.pspes.modifiedPointStoreProduct.ProductEnd.length <= 0)
                    return this.getLocalizationText('MarketPlace_Management', 'Ongoing', 'Ongoing');
                else return formatDate(this.pspes.modifiedPointStoreProduct.ProductEnd, this.DateFormat, this.locale);
                break;
            case "variationName":
                return `${this.pspes.modifiedPointStoreProduct.VariationsData.length} ${this.pspes.modifiedPointStoreProduct.VariationName}`;
                break;
        }
    };

    getDisplaySettings(property: string): string | null {
        if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
            return "";

        const product = this.pspes.modifiedPointStoreProduct;
        const formatDateIfView = (date, forView) => forView && date ? formatDate(date, this.DateFormat, this.locale) : null;
        const getLocalizedYesNo = (isChecked) => isChecked ? this.getLocalizationText('MarketPlace_Management', 'Yes', 'Yes') : this.getLocalizationText('MarketPlace_Management', 'No', 'No');

        switch (property) {
            case "carouselStart":
                return formatDateIfView(product.CarouselStart, product.CarouselStart_ForView);
            case "carouselEnd":
                return formatDateIfView(product.CarouselEnd, product.CarouselEnd_ForView);
            case "isCarouselChecked":
                return getLocalizedYesNo(product.IsCarouselChecked);
            case "featureStart":
                return formatDateIfView(product.FeatureStart, product.FeatureStart_ForView);
            case "featureEnd":
                return formatDateIfView(product.FeatureEnd, product.FeatureEnd_ForView);
            case "isFeatureChecked":
                return getLocalizedYesNo(product.IsFeaturedChecked);
            case "saleStart":
                return formatDateIfView(product.SaleStart, product.SaleStart_ForView);
            case "saleEnd":
                return formatDateIfView(product.SaleEnd, product.SaleEnd_ForView);
            case "isSaleChecked":
                return product.Sale;
            default:
                return null;
        }
    }

    getPreviewSource() {
        if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
            return "";

        if (this.pspes.modifiedPointStoreProduct.imageString != null && this.pspes.modifiedPointStoreProduct.imageString.length > 0)
            return this.pspes.modifiedPointStoreProduct.imageString[0].source;
        else if (this.pspes.modifiedPointStoreProduct.ProductImageID != 0 && (this.pspes.modifiedPointStoreProduct.imageString == null || this.pspes.modifiedPointStoreProduct.imageString.length <= 0))
            return "../Admin/ImageResizer.aspx?imgid=" + this.pspes.modifiedPointStoreProduct.ProductImageID + "&w=auto&h=190";
        else if (this.pspes.modifiedPointStoreProduct.VariationsData != null && this.pspes.modifiedPointStoreProduct.VariationsData.some((variation) => variation.VariationImageData != null))
            return this.pspes.modifiedPointStoreProduct.VariationsData[0].VariationImageData;
        else
            return "../Admin/ImageResizer.aspx?imgid=-15&w=auto&h=190";
    };

    isMainImageEmptyWithMultiplesImages(): boolean {
        let status = false;
        if (
            this.pspes.modifiedPointStoreProduct.HasMultipleImages &&
            (this.pspes.modifiedPointStoreProduct.ProductImageID == 0 ||
                this.pspes.modifiedPointStoreProduct.ProductImageID == null)
        ) {
            status = true;
        } else {
            status = false;
        }
        return status;
    }

    productHasMultipleImages() {
        let productImagesCount = 0;
        if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct != null) {
            if (this.pspes.modifiedPointStoreProduct.VariationsData != null && this.pspes.modifiedPointStoreProduct.HasProductVariations) {
                this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation, index, array) => {
                    if (variation.VariationImageData != undefined && variation.VariationImageData != null)
                        productImagesCount++;
                });
            }
            if (productImagesCount > 0 || (this.pspes.modifiedPointStoreProduct.imageString != undefined && this.pspes.modifiedPointStoreProduct.imageString.length > 1))
                return true;
        }
    }

    getMultipleImagesCount() {
        let productImagesCount = 0;
        if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct != null) {
            if (this.pspes.modifiedPointStoreProduct.VariationsData != null && this.pspes.modifiedPointStoreProduct.HasProductVariations) {
                this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation, index, array) => {
                    if (variation.VariationImageData != undefined && variation.VariationImageData != null)
                        productImagesCount++;
                });
            }
            if (this.pspes.modifiedPointStoreProduct.imageString != undefined && (this.pspes.modifiedPointStoreProduct.imageString.length > 1 || productImagesCount > 0)) {
                productImagesCount += this.pspes.modifiedPointStoreProduct.imageString.length;
                return productImagesCount - 1;
            }
        }
    }

    checkImageNotAvailable(): boolean {
        const product = this.pspes.modifiedPointStoreProduct;
        const hasImage = product.imageString?.length ?? 0 > 0;
        const hasVariationImage = product.HasProductVariations && (product.VariationsData?.some(variation => variation.VariationImageData != null) ?? false);

        if (product.PointStoreProductID > 0) { // update mode
            return !hasImage && !hasVariationImage;
        } else { // create mode
            return !hasImage && !hasVariationImage;
        }
    }

    getImageNotAvailableTitle(): string {
        return this.cvLocalizationService.getCachedText("MarketPlace_Management", "Image_Not_Available", "Image_Not_Available");
    }

    checkSaleVariationPrice() {
        this.saleVariationFlag = false;
        this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
            if (variation.VariationPrice == this.initialVariationPrice.VariationPrice && variation.VariationOnSale)
                this.saleVariationFlag = true;
        });
        if (this.saleVariationFlag) {
            return Math.ceil(this.initialVariationPrice.VariationPrice - (this.initialVariationPrice.VariationPrice * this.pspes.modifiedPointStoreProduct.Sale / 100));
        }
    }

    getMinMaxVariationPrice(type: 'min' | 'max'): number | string {
        const product = this.pspes?.modifiedPointStoreProduct;

        if (!product?.VariationsData) {
            return "";
        }

        const variationPrices = product.VariationsData.map(variation => {
            let variationPrice = Number(variation.VariationPrice?.toString().replace(/,/g, ''));

            if (variation.VariationOnSale && this.isSaleActive()) {
                variationPrice -= variationPrice * (product.Sale / 100);
                return Math.ceil(variationPrice);
            }

            return variationPrice;
        });

        return type === 'min' ? Math.min(...variationPrices) : Math.max(...variationPrices);
    }

    isSaleActive() {
        if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
            return false;

        if (
            this.pspes.modifiedPointStoreProduct.SaleStart != null &&
            this.pspes.modifiedPointStoreProduct.SaleStart <= new Date() &&
            (this.pspes.modifiedPointStoreProduct.SaleEnd == null ||
                (this.pspes.modifiedPointStoreProduct.SaleEnd != null &&
                    this.pspes.modifiedPointStoreProduct.SaleEnd >= new Date()))
        )
            return true;

        return false;
    };

    isFeatureActive() {
        if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
            return false;

        if (
            this.pspes.modifiedPointStoreProduct.FeatureStart != null &&
            this.pspes.modifiedPointStoreProduct.FeatureStart <= new Date() &&
            (this.pspes.modifiedPointStoreProduct.FeatureEnd == null ||
                (this.pspes.modifiedPointStoreProduct.FeatureEnd != null &&
                    this.pspes.modifiedPointStoreProduct.FeatureEnd >= new Date()))
        )
            return true;

        return false;
    };

    getAgentPrice() {
        if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
            return "";

        if (this.isSaleActive()) {
            let price = Number(this.pspes.modifiedPointStoreProduct.Price?.toString().replace(/,/g, ''));
            return Math.ceil(price * ((100 - this.pspes.modifiedPointStoreProduct.Sale) / 100));
        }
        return this.pspes.modifiedPointStoreProduct.Price;
    };

    getQty() {
        if (this.pspes.modifiedPointStoreProduct != null && this.pspes.modifiedPointStoreProduct.VariationsData != null)
            return Object.values(this.pspes.modifiedPointStoreProduct.VariationsData).length;
    }

    getLocalizationText(section: string, key: string, defaultValue: string): string {
        return this.cvLocalizationService.getCachedText(section, key, defaultValue);
    }

    prodSettingsOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            visibility: 'visible',
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "custom-scrollbar"
        },
        overflow: {
            x: 'hidden',
            y: 'scroll'
        },
    };
}
